import { render, staticRenderFns } from "./ChainsJsonPage.vue?vue&type=template&id=2e6caecf"
import script from "./ChainsJsonPage.vue?vue&type=script&lang=js"
export * from "./ChainsJsonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports